export default "__VITE_ASSET__DciyDe1E__"